import {apiClient} from "@/state/modules/apiClient";
const controller = "Files";
export const actions = {
    async viewFile({commit}, id) {
        return apiClient.getFile(controller + "/view/" + id);
    }
};
